// src/context/activeEditor.tsx
import { Editor } from "@tiptap/react";
import React, { createContext, useContext, useMemo, useState } from "react";

interface ActiveEditorContextValue {
  activeEditor: Editor | null;
  setActiveEditor: React.Dispatch<React.SetStateAction<Editor | null>>;
}

const ActiveEditorContext = createContext<ActiveEditorContextValue | null>(null);

export const ActiveEditorProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [activeEditor, setActiveEditor] = useState<Editor | null>(null);
  const value = useMemo(
    () => ({ activeEditor, setActiveEditor }),
    [activeEditor],
  );
  return (
    <ActiveEditorContext.Provider value={value}>
      {children}
    </ActiveEditorContext.Provider>
  );
};

export const useActiveEditor = (): ActiveEditorContextValue => {
  const ctx = useContext(ActiveEditorContext);
  if (!ctx) {
    throw new Error("useActiveEditor must be used within ActiveEditorProvider");
  }
  return ctx;
};
